import { COMMON } from '../../Enum/EndPoint/CommonEndpoint';

export const PRODUCT_GROUP_URL = Object.freeze({
  COUNT: COMMON.MAPPING + COMMON.MAPPING_TYPE.PRODUCT_GROUP + COMMON.COUNT,
  LIST: function list(page, limit, order) {
    return COMMON.MAPPING + COMMON.MAPPING_TYPE.PRODUCT_GROUP + COMMON.LIST(page, limit, order);
  },
  REJECT: COMMON.MAPPING + COMMON.MAPPING_TYPE.PRODUCT_GROUP + COMMON.REJECT,
  DETAIL: COMMON.MAPPING + COMMON.MAPPING_TYPE.PRODUCT_GROUP + COMMON.INDEX,
  DETAIL_EXISTING: COMMON.MAPPING + COMMON.MAPPING_TYPE.PRODUCT_GROUP + COMMON.EXISTING,
  SEARCH: COMMON.MAPPING + COMMON.MAPPING_TYPE.PRODUCT_GROUP + COMMON.SEARCH,
  COUNT_SEARCH: COMMON.MAPPING + COMMON.MAPPING_TYPE.PRODUCT_GROUP + COMMON.SEARCH + COMMON.COUNT,
  MAPPING_APPROVE: COMMON.MAPPING + COMMON.MAPPING_TYPE.PRODUCT_GROUP + COMMON.APPROVE,

  PRINCIPAL:{
    COUNT: COMMON.MAPPING + COMMON.MAPPING_TYPE.PRINCIPAL_PRODUCT_GROUP + COMMON.COUNT,
  LIST: function list(page, limit, order) {
    return COMMON.MAPPING + COMMON.MAPPING_TYPE.PRINCIPAL_PRODUCT_GROUP + COMMON.LIST(page, limit, order);
  },
  REJECT: COMMON.MAPPING + COMMON.MAPPING_TYPE.PRINCIPAL_PRODUCT_GROUP + COMMON.REJECT,
  DETAIL: COMMON.MAPPING + COMMON.MAPPING_TYPE.PRINCIPAL_PRODUCT_GROUP + COMMON.INDEX,
  DETAIL_EXISTING: COMMON.MAPPING + COMMON.MAPPING_TYPE.PRINCIPAL_PRODUCT_GROUP + COMMON.EXISTING,
  SEARCH: COMMON.MAPPING + COMMON.MAPPING_TYPE.PRINCIPAL_PRODUCT_GROUP + COMMON.SEARCH,
  COUNT_SEARCH: COMMON.MAPPING + COMMON.MAPPING_TYPE.PRINCIPAL_PRODUCT_GROUP + COMMON.SEARCH + COMMON.COUNT,
  MAPPING_APPROVE: COMMON.MAPPING + COMMON.MAPPING_TYPE.PRINCIPAL_PRODUCT_GROUP + COMMON.APPROVE,
  }
});
